// extracted by mini-css-extract-plugin
module.exports = {"on-hover":"article-card_on-hover__988NM","shadow":"article-card_shadow__rNuRn"};